import React from 'react';
//Context
import { MonitoreoProvider } from './MonitoreoContext';
//Styles
import '../../styles/monitoreo.css';
//Components
import GraphStatus from './GraphStatus';
import SimpleTabs from './TabIndi';
import LinearGraph from './LinearGraph';
import TablaAndon from './TablaAndon';
import GaugeResponseTime from './GaugeResponseTime';
import SelectJerarquia from './SelectJerarquia';
import { useHistory } from 'react-router-dom';

function Monitoreo() {
    return (
        <div className="monitoreoView">
            <div className="MonitoreoView-head">
                <div className="monitoreoView-head-title">
                    <h1 className="monitoreoView-head-titulo">Monitoreo</h1>
                </div>
                <div className="monitoreoView-head-filters">
                    <div className="monitoreoView-head-filters-card">
                        <SelectJerarquia />
                    </div>
                </div>
            </div>

            <div className="monitoreoView-body">
                {/* ARRIBA: Corrida actual (izquierda) + selector de rango (derecha) */}
                <div className="monitoreoView-body-tittle">
                    <div className="monitoreoView-body-tittle-first-left">
                        <LinearGraph />
                    </div>
                    <div className="monitoreoView-body-tittle-first-rigth">
                        <SimpleTabs />
                    </div>
                </div>

                {/* ESTATUS DE LÍNEA */}
                <div className="monitoreo-status-section">
                    <GraphStatus />
                </div>

                {/* ABAJO: Counters + Tabla Andon (izquierda) + Gauge (derecha) */}
                <div className="monitoreo-bottom-section">
                    <div className="monitoreo-andon-panel">
                        <p className="andon-section-title">Llamadas Andon Activas</p>
                        <TablaAndon />
                    </div>
                    <div className="monitoreo-widgets-panel">
                        <GaugeResponseTime />
                    </div>
                </div>
            </div>
        </div>
    );
}

let MonitoreoProviderComp = () => {
    let history = useHistory();
    if (!process.env.REACT_APP_ALLOW_MONITORING_VIEW) {
        history.replace('/');
        return null;
    }
    return (
        <MonitoreoProvider>
            <Monitoreo />
        </MonitoreoProvider>
    );
};

export default MonitoreoProviderComp;
